export var ErrorCode;
(function (ErrorCode) {
    ErrorCode["InternalJobError"] = "INTERNAL_JOB_ERROR";
    ErrorCode["JobCanceledError"] = "JOB_CANCELED_ERROR";
    ErrorCode["CloudOperationFailed"] = "CLOUD_OPERATION_FAILED";
    ErrorCode["FailedToGetResourceInformation"] = "FAILED_TO_GET_RESOURCE_INFORMATION";
    ErrorCode["ResourceIsTerminated"] = "RESOURCE_IS_TERMINATED";
    ErrorCode["InvalidResourceState"] = "INVALID_RESOURCE_STATE";
    ErrorCode["InvalidResourceConfiguration"] = "INVALID_RESOURCE_CONFIGURATION";
    ErrorCode["ResourceConflict"] = "RESOURCE_CONFLICT";
    ErrorCode["UnsupportedOperationOnResource"] = "UNSUPPORTED_OPERATION_ON_RESOURCE";
    ErrorCode["FailedToCreateResource"] = "FAILED_TO_CREATE_RESOURCE";
    ErrorCode["FailedToStartResource"] = "FAILED_TO_START_RESOURCE";
    ErrorCode["FailedToStopResource"] = "FAILED_TO_STOP_RESOURCE";
    ErrorCode["FailedToGetStorageInformation"] = "FAILED_TO_GET_STORAGE_INFORMATION";
    ErrorCode["FailedToCreateStorage"] = "FAILED_TO_CREATE_STORAGE";
    ErrorCode["FailedToDeleteStorage"] = "FAILED_TO_DELETE_STORAGE";
    ErrorCode["FailedToAttachStorage"] = "FAILED_TO_ATTACH_STORAGE";
    ErrorCode["FailedToDetachStorage"] = "FAILED_TO_DETACH_STORAGE";
    ErrorCode["FailedToCreateImage"] = "FAILED_TO_CREATE_IMAGE";
    ErrorCode["FailedToGetSnapshotInformation"] = "FAILED_TO_GET_SNAPSHOT_INFORMATION";
    ErrorCode["FailedToTakeSnapshot"] = "FAILED_TO_TAKE_SNAPSHOT";
    ErrorCode["FailedToUseSnapshot"] = "FAILED_TO_USE_SNAPSHOT";
    ErrorCode["FailedToDeleteSnapshot"] = "FAILED_TO_DELETE_SNAPSHOT";
    ErrorCode["SnapshotQuotaExceeded"] = "SNAPSHOT_QUOTA_EXCEEDED";
    ErrorCode["ResourceUsageQuotaExceeded"] = "RESOURCE_USAGE_QUOTA_EXCEEDED";
    ErrorCode["AuthenticationFailure"] = "AUTHENTICATION_FAILURE";
    ErrorCode["InvalidAccountConfiguration"] = "INVALID_ACCOUNT_CONFIGURATION";
    ErrorCode["InvalidVaultConfiguration"] = "INVALID_VAULT_CONFIGURATION";
    ErrorCode["InvalidInputParameters"] = "INVALID_INPUT_PARAMETERS";
    ErrorCode["TooManyRequests"] = "TOO_MANY_REQUESTS";
    ErrorCode["BackupConflict"] = "BACKUP_CONFLICT";
    ErrorCode["ClassificationConflict"] = "CLASSIFICATION_CONFLICT";
    ErrorCode["FailedToRunQuery"] = "FAILED_TO_RUN_QUERY";
    ErrorCode["OperationDeniedByConfiguration"] = "OPERATION_DENIED_BY_CONFIGURATION";
    ErrorCode["InsufficientEncryptionPermissions"] = "INSUFFICIENT_ENCRYPTION_PERMISSIONS";
})(ErrorCode || (ErrorCode = {}));
